<div class="d-flex flex-column flex-nowrap campaign-influencers-item">
  <div class="d-flex flex-g1">
    <div class="d-flex flex-row flex-auto campaign-influencers-content-wrapper full-width">
      <div class="d-flex campaign-influencer-info">
        <div class="d-flex flex-row flex-auto open-influencer full-width">
          <div class="d-flex flex-auto align-items-center full-width">
            <div class="d-flex flex-row flex-auto full-width">
              <div class="d-flex align-items-center post-image-container">
                <a (click)="openCampaignPost()">
                  <blurry-backdrop-image class="post-img" [image]="post.imageUrl"></blurry-backdrop-image>
                </a>
              </div>
              <div class="d-flex align-items-center post-content">
                <div class="nowrap-input d-flex flex-column justify-content-center full-width">
                  <div class="nowrap-input campaign-influencer-name">{{ post.title }}</div>
                  <span class="campaign-post-date">{{post.date | date: 'd MMMM yyyy' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex campaign-influencer-posts-platforms">
        <div class="d-flex flex-row flex-auto align-items-center">
          <div class="border-left"></div>
          <div class="d-flex flex-auto campaign-influencer-platforms">
            <img *ngIf="post.platformBlogs" src="/assets/images/platform/Blogger.svg" class="platform-icon">
            <img *ngIf="post.platformFacebook" src="/assets/images/platform/Facebook.svg" class="platform-icon">
            <img *ngIf="post.platformInstagram" src="/assets/images/platform/Instagram.svg" class="platform-icon">
            <img *ngIf="post.platformYoutube" src="/assets/images/platform/Youtube.svg" class="platform-icon">
            <img *ngIf="post.platformSnapchat" src="/assets/images/platform/Snapchat.svg" class="platform-icon">
            <img *ngIf="post.platformTwitter" src="/assets/images/platform/Twitter.svg" class="platform-icon">
            <img *ngIf="post.platformPinterest" src="/assets/images/platform/Printerest.svg" class="platform-icon">
          </div>
        </div>
      </div>
      <div class="d-flex campaign-influencer-reach">
        <div class="d-flex flex-row flex-auto align-items-center">
          <div class="border-left"></div>
          <span class="camp-number">{{post.reach | thousandNumberSuffix}}</span>
        </div>
      </div>
      <div class="d-flex campaign-influencer-engagement">
        <div class="d-flex flex-row flex-auto align-items-center">
          <div class="border-left"></div>
          <span class="camp-number">{{post.engagement | thousandNumberSuffix}}</span>
        </div>
      </div>
      <div class="d-flex campaign-influencer-impact-percent">
        <div class="d-flex flex-row flex-auto align-items-center">
          <div class="border-left"></div>
          <span class="camp-number">{{campaignInfluencerImpact | percentNumberSuffix}}</span>
        </div>
      </div>
      <div class="d-flex campaign-influencer-button">
        <div class="d-flex flex-row flex-auto align-items-center justify-content-end mr-20px">
          <a (click)="openCampaignPost()"
             placement="bottom" ngbTooltip="{{'info_box.campaign.arrow_icon' | translate}}">
            <img height="30" src="assets/images/Arrow_Right.svg" width="20">
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-g1 campaign-border-bottom"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/fb-testing-page/campaign-post-item/campaign-post-item.component.html